import { Component } from '@angular/core';

@Component({
    selector: 'app-social-instagram',
    templateUrl: './social-instagram.component.html',
    standalone: false
})
export class SocialInstagramComponent {
}
